// extracted by mini-css-extract-plugin
export default {"main_container":"App_main_container__VrYc-","header":"App_header__fhC8n","tv_show_detail":"App_tv_show_detail__sUegH","recommended_tv_shows":"App_recommended_tv_shows__+Lexg"};